<template>
    <div>
        <LoadingOverlay :loading="loading" />
        <div class="topThreeRewards-box">
            <div class="rewardsBoxes">
                <div class="rewardsBox">
                    <div class="rewardsBox-In" @click="redirectProfile(CharmLastweekData[1].user.id, CharmLastweekData[1].user.profile_id, CharmLastweekData[1].user.charm_level)">
                        <div class="rewardsProfile-imageBox">
                            <img :src='ProfileFrame2' class="profile-imgFrame" alt="pf-frame" />
                            <div class="profile-imageBox" v-if="CharmLastweekData.length > 1">
                                <img class="overlapImg" :src='CharmLastweekData[1].user.profile_images[0].image_name'
                                    alt="User Image" />
                            </div>
                            <div class="rewards-level" v-if="CharmLastweekData.length > 1">
                                <img :src="getLevelImage(CharmLastweekData[1].user.charm_level)" class="lavelImage" alt="level icon" />
                                <span class="lavel-value">{{ CharmLastweekData[1].user.charm_level }}</span>
                            </div>
                        </div>
                        <div class="userName-box">
                            <div class="userName" v-if="CharmLastweekData.length > 1">
                                {{ CharmLastweekData[1].user.name }}
                            </div>
                            <div class="beansBox">
                                <img :src='beansIcon' class="beansIcon" alt="" />
                                <span class="beansValue" v-if="CharmLastweekData.length > 1">{{
                                CharmLastweekData[1].total_coin_earned
                            }}</span>
                            </div>
                            <div class="userRewardsBox mt-0" v-if="CharmLastweekData.length > 1">
                                <div v-if="CharmLastweekData[1].reward_coin > 0">
                                    <span>Reward</span>{{ CharmLastweekData[1].reward_coin }}
                                </div>
                                <div class="rewardBlast-orangeText" v-if="CharmLastweekData[1].reward_blast > 0">
                                    <span>Blast Reward</span>{{ CharmLastweekData[1].reward_blast }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rewardsBox center-rewardsBox">
                    <div class="rewardsBox-In" @click="redirectProfile(CharmLastweekData[0].user.id, CharmLastweekData[0].user.profile_id, CharmLastweekData[0].user.charm_level)">
                        <div class="rewardsProfile-imageBox">
                            <img :src='ProfileFrame1' class="profile-imgFrame" alt="pf-frame" />
                            <div class="profile-imageBox" v-if="CharmLastweekData.length > 0">
                                <img class="overlapImg" :src='CharmLastweekData[0].user.profile_images[0].image_name'
                                    alt="User Image" />
                            </div>
                            <div class="rewards-level" v-if="CharmLastweekData.length > 0">
                                <img :src="getLevelImage(CharmLastweekData[0].user.charm_level)" class="lavelImage" alt="level icon" />
                                <span class="lavel-value">{{ CharmLastweekData[0].user.charm_level }}</span>
                            </div>
                        </div>
                        <div class="userName-box">
                            <div class="userName" v-if="CharmLastweekData.length > 0">{{ CharmLastweekData[0].user.name
                                }}</div>
                            <div class="beansBox">
                                <img :src='beansIcon' class="beansIcon" alt="" />
                                <span class="beansValue" v-if="CharmLastweekData.length > 0">{{
                                CharmLastweekData[0].total_coin_earned
                            }}</span>
                            </div>
                            <div class="userRewardsBox mt-0" v-if="CharmLastweekData.length > 0">
                                <div v-if="CharmLastweekData[0].reward_coin > 0">
                                    <span>Reward</span>{{ CharmLastweekData[0].reward_coin }}
                                </div>
                                <div class="rewardBlast-orangeText" v-if="CharmLastweekData[0].reward_blast > 0">
                                    <span>Blast Reward</span>{{ CharmLastweekData[0].reward_blast }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="rewardsBox">
                    <div class="rewardsBox-In" @click="redirectProfile(CharmLastweekData[2].user.id, CharmLastweekData[2].user.profile_id, CharmLastweekData[2].user.charm_level)">
                        <div class="rewardsProfile-imageBox">
                            <img :src='ProfileFrame3' class="profile-imgFrame" alt="pf-frame" />
                            <div class="profile-imageBox" v-if="CharmLastweekData.length > 2">
                                <img class="overlapImg" :src='CharmLastweekData[2].user.profile_images[0].image_name'
                                    alt="User Image" />
                            </div>
                            <div class="rewards-level" v-if="CharmLastweekData.length > 2">
                                <img :src="getLevelImage(CharmLastweekData[2].user.charm_level)" class="lavelImage" alt="level icon" />
                                <span class="lavel-value">{{ CharmLastweekData[2].user.charm_level }}</span>
                            </div>
                        </div>
                        <div class="userName-box">
                            <div class="userName" v-if="CharmLastweekData.length > 2">{{ CharmLastweekData[2].user.name
                                }}</div>
                            <div class="beansBox">
                                <img :src='beansIcon' class="beansIcon" alt="" />
                                <span class="beansValue" v-if="CharmLastweekData.length > 2">{{
                                CharmLastweekData[2].total_coin_earned
                            }}</span>
                            </div>
                            <div class="userRewardsBox mt-0" v-if="CharmLastweekData.length > 2">
                                <div v-if="CharmLastweekData[2].reward_coin > 0">
                                    <span>Reward</span>{{ CharmLastweekData[2].reward_coin }}
                                </div>
                                <div class="rewardBlast-orangeText" v-if="CharmLastweekData[2].reward_blast > 0">
                                    <span>Blast Reward</span>{{ CharmLastweekData[2].reward_blast }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="podiumImageBox">
                <img class="podiumImage" :src='podiumImage' alt="Podium Image" />
            </div>
        </div>
        <div class="fixHeight ringlive-datalistWrap">
            <div class="listBoxes" v-for="(reward, index) in CharmLastweekData.slice(3) " :key="reward.id" @click="redirectProfile(reward.user.id, reward.user.profile_id, reward.user.charm_level)">
                <div class="leftBxb">
                    <div class="s-no">{{ index + 4 }}</div>
                    <div class="listIconBox">
                        <div class="profPic">
                            <img :src='(reward.user.profile_images.length > 0) ? reward.user.profile_images[0].image_name : defaultUserImage'
                                alt="User Image" />
                        </div>
                    </div>
                    <div class="name-lavel-box">
                        <div class="userName">{{ reward.user.name }}
                        </div>
                        <div class="lavel-box">
                            <img :src="getLevelImage(reward.user.charm_level)" class="lavelImage" alt="level icon" />
                            <span class="lavel-value">{{ reward.user.charm_level }}</span>
                        </div>
                    </div>
                </div>
                <div class="rightBox">
                    <div class="rightBox-in">
                        <div class="beansBox">
                            <img :src='beansIcon' class="beansIcon" alt="beans icons" />
                            {{ reward.total_coin_earned }}
                        </div>
                        <div class="userRewardsBox" v-if="reward.reward_coin > 0">
                            <span>Reward</span>{{ reward.reward_coin }}
                        </div>
                        <div class="userRewardsBox rewardBlast-orangeText" v-if="reward.reward_blast > 0">
                            <span>Blast Reward</span>{{ reward.reward_blast }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="personalDetails" class="listBoxes myselfBox" @click="redirectProfile(personalDetails.id, personalDetails.profile_id, personalDetails.charm_level)">
            <div class="leftBxb">
                <div class="s-no">-</div>
                <div class="listIconBox">
                    <div class="profPic">
                        <!-- <img :src='(personalDetails.profile_images.length > 0) ? personalDetails.profile_images[0].image_name : defaultUserImage'
                            alt="User Image" /> -->
                        <img :src="personalDetails.profile_images.length > 0 ? personalDetails.profile_images[0].image_name : defaultUserImage"
                        alt="User Image" @error="setDefaultImage" />
                    </div>
                </div>
                <div class="name-lavel-box">
                    <div class="userName">{{ personalDetails.name }}</div>
                    <div class="lavel-box">
                        <img :src="getLevelImage(personalDetails.charm_level)" class="lavelImage" alt="level icon" />
                        <span class="lavel-value">{{ personalDetails.charm_level }}</span>
                    </div>
                </div>
            </div>
            <div class="rightBox">
                <div class="rightBox-in">
                    <img :src='beansIcon' class="beansIcon" alt="beans icons" />
                    {{ personalDetails.weekly_earning_beans }}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import ProfileFrame1 from '../../assets/images/rank1-frameImage.png'
import ProfileFrame2 from '../../assets/images/rank2-frameImage.png'
import ProfileFrame3 from '../../assets/images/rank3-frameImage.png'
import beansIcon from '../../assets/images/beansIcon.png'
import podiumImage from '../../assets/images/podium-background.webp'
import defaultUserImage from '../../assets/images/default_profile.webp';
import LoadingOverlay from '../LoadingOverlay.vue'
export default {
    name: 'LastWeekTabCont',
    components: {
        LoadingOverlay
    },
    data() {
        return {
            CharmLastweekData: [],
            personalDetails: null,
            ProfileFrame1: ProfileFrame1,
            ProfileFrame2: ProfileFrame2,
            ProfileFrame3: ProfileFrame3,
            beansIcon: beansIcon,
            podiumImage: podiumImage,
            defaultUserImage: defaultUserImage,
            loading: false,
        }
    },
    watch: {
        '$route.params.profile_id': 'fetchCharmLastweekData'
    },
    mounted() {
        this.fetchCharmLastweekData();
    },
    methods: {
        fetchCharmLastweekData() {
            this.loading = true;
            const tokenParam = this.$route.params.token;
            const token = tokenParam.split('=')[0];
            // const apiUrl = `https://ringlive.in/api/top-charm-weekly?type=last_week`;
            const apiUrl = `api/top-charm-weekly?type=last_week`;
            axios.get(apiUrl, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            })
                .then(response => {
                    this.CharmLastweekData = response.data.result.data;
                    this.personalDetails = response.data.result.personal_details;
                    this.checkAllImagesExist();
                })

                .catch(error => {
                    console.error("Error Featching This Week Data", error)
                })
                .finally(() => {
                    this.loading = false;
                })
        },
        getLevelImage(charm_level) {            
            switch (true) {
                case charm_level === 0:
                return require('@/assets/images/charm-lavel-0.png');
                case charm_level === 1:
                return require('@/assets/images/charm-lavel-1.png');
                case charm_level === 2:
                return require('@/assets/images/charm-lavel-2.png');
                case charm_level === 3:
                return require('@/assets/images/charm-lavel-3.png');
                case charm_level === 4:
                return require('@/assets/images/charm-lavel-4.png');
                case charm_level === 5:
                return require('@/assets/images/charm-lavel-5.png');
                case charm_level >= 6 && charm_level <= 10:
                return require('@/assets/images/charm-lavel-6-10.png');
                case charm_level >= 11 && charm_level <= 15:
                return require('@/assets/images/charm-lavel-11-15.png');
                case charm_level >= 16 && charm_level <= 40:
                return require('@/assets/images/charm-lavel-16-20.png');
                default:
                return require('@/assets/images/charm-lavel-0.png'); // Ensure you have a default image
            }      
        },
        checkAllImagesExist() {
            this.CharmLastweekData.forEach(reward => {
                if (reward.user.profile_images.length > 0) {
                    const imageUrl = reward.user.profile_images[0].image_name;
                    this.checkImageExists(imageUrl)
                        .then(exists => {
                            if (!exists) {
                                reward.user.profile_images[0].image_name = this.defaultUserImage;
                            }
                        });
                } else {
                    reward.user.profile_images = [{ image_name: this.defaultUserImage }];
                }
            });
        },
        checkImageExists(imageUrl) {
            return new Promise((resolve) => {
                var img = new Image();
                img.onload = function () {
                    resolve(true);
                };
                img.onerror = function () {
                    resolve(false);
                };
                img.src = imageUrl;
            });
        },

        setDefaultImage(event) {
            event.target.src = this.defaultUserImage;
        },
        
        redirectProfile(id, profile_id, level) {
            if (window.navigator.userAgent.indexOf("Android") > -1) {
                const baseURL = 'female-weekly-rewards';
                const params = {
                    id: id,
                    profile_id: profile_id,
                    level: level
                };
                const queryString = Object.keys(params)
                    .map(key => `${key}=${params[key]}`)
                    .join('&');
                const url = `${baseURL}?${queryString}`;                
                //   window.location.href = url;
                Android.redirectProfile(url);
            }

        }

    },
}
</script>